import React from "react";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function Home({ user }) {
  const navigate = useNavigate();

  React.useEffect(() => {
    (async () => {
      const response = await fetch(
        `${process.env.REACT_APP_DB_URL}/user_office/${user}`
      );
      const res = await response.json();
      console.log("office: ", res[0].office);
      navigate(`/${res[0].office === 'TX' ? 'TX' : 'NY'}`, { replace: true });
    })();
  }, []);

  return (
    <Box
      sx={{
        height: "50vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
